import $ from '@nodeModules/jquery';
import '@nodeModules/slick-carousel-latest';
import { debounce } from '@nodeModules/throttle-debounce';

export const initPageJs = () => {
	const $heroPrevArrowEl = document.querySelector('.hero__slider-nav-action--prev');
	const $heroNextArrowEl = document.querySelector('.hero__slider-nav-action--next');

	$('.hero__slider').on('init', function(event, slick) {
		const $currentSlide = document.querySelector(`[data-slide-index="${Number(1)}"]`);
    	if ($currentSlide) {
    		window.track.trackViewPromotion($currentSlide.dataset);
    	}

		if (slick.$slides.length > 2) {
			slick.$slides[0].classList.add('hero__slide--index-2');
		}

		const $heroSliderWrap = document.querySelector('.hero__slider-wrap');
		$heroSliderWrap.classList.add('hero__slider-wrap--is-initialized');

		if ($heroPrevArrowEl && $heroNextArrowEl) {
			const $heroContainer = document.querySelector('.hero__container');
			const $mainSlide = document.querySelector('.slick-active.slick-center a');

			$heroPrevArrowEl.style.width = `${($heroContainer.offsetWidth - $mainSlide.offsetWidth) / 2}px`;
			$heroNextArrowEl.style.width = `${($heroContainer.offsetWidth - $mainSlide.offsetWidth) / 2}px`;
		}
	}).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	    const direction = currentSlide - nextSlide;
		slick.$slides.removeClass('hero__slide--next');

		$('.hero__slider .slick-cloned').removeClass('slick-center');
		$('.hero__slider .slick-slide').removeClass('hero__slide--prev-active');

		if (slick.$slides.length - direction === 1) {
			const clonedEl = $('.hero__slide.slick-cloned.slick-active');
			clonedEl.addClass('slick-cloned-center--next');

			setTimeout(() => {
				clonedEl.removeClass('slick-cloned-center--next');
			}, '1000');
		}

		if (direction + slick.$slides.length === 1) {
			const clonedEl = $('.hero__slide.slick-cloned.slick-active');
			clonedEl.addClass('slick-cloned-center--prev');

			setTimeout(() => {
				clonedEl.removeClass('slick-cloned-center--prev');
			}, '1000');
		}

		if (direction > 0) {
			if (direction !== 1) {

	  			slick.$slides[nextSlide].classList.add('hero__slide--index-1');
				slick.$slides[currentSlide].classList.add('hero__slide--index-1');

	  			setTimeout(() => {
	  				slick.$slides[nextSlide].classList.add('hero__slide--index-2');
					slick.$slides[currentSlide].classList.remove('hero__slide--index-2');
	  				slick.$slides[nextSlide].classList.remove('hero__slide--index-1');
				}, '250');

				setTimeout(() => {
					slick.$slides[currentSlide].classList.remove('hero__slide--index-1');
				}, '500');
			} else {
				slick.$slides[currentSlide].classList.add('hero__slide--index-1');
				slick.$slides[currentSlide].classList.remove('hero__slide--index-2');

				setTimeout(() => {
	  				slick.$slides[nextSlide].classList.add('hero__slide--index-2');
				}, '250');

				setTimeout(() => {
					slick.$slides[currentSlide].classList.remove('hero__slide--index-1');
				}, '1000');
			}
		} else if (direction === 0) {
			slick.$slides[currentSlide].classList.add('hero__slide--index-2');
		} else {
			slick.$slides[nextSlide].classList.add('hero__slide--next');

			if (direction !== -1) {
  				slick.$slides[nextSlide].classList.add('hero__slide--index-2');
				slick.$slides[currentSlide].classList.add('hero__slide--index-1');
				slick.$slides[currentSlide].classList.remove('hero__slide--index-2');

				if (direction !== -2) {
					setTimeout(() => {
						slick.$slides[currentSlide].classList.remove('hero__slide--index-1');
					}, '1000');
				} else {
					setTimeout(() => {
						slick.$slides[currentSlide].classList.remove('hero__slide--index-1');
					}, '500');
				}
			} else {
				slick.$slides[nextSlide].classList.add('hero__slide--index-1');

				setTimeout(() => {
					slick.$slides[currentSlide].classList.remove('hero__slide--index-2');
	  				slick.$slides[nextSlide].classList.add('hero__slide--index-2');
					slick.$slides[nextSlide].classList.remove('hero__slide--index-1');
				}, '250');
			}
		}
	}).on('afterChange', function(event, slick, currentSlide) {
		const $heroActiveSlides = $('.hero__slider .hero__slide.slick-active');
		if ($heroActiveSlides[0].previousSibling) {
			$heroActiveSlides[0].previousSibling.classList.add('hero__slide--prev-active');
		}

		const $currentSlide = document.querySelector(`[data-slide-index="${Number(currentSlide + 1)}"]`);
    	if ($currentSlide) {
    		window.track.trackViewPromotion($currentSlide.dataset);
    	}
  	}).slick({
		slidesToShow: 3,
		waitForAnimate: false,
		centerMode: true,
		draggable: false,
		centerPadding: '0',
		autoplay: true,
		dots: true,
		dotsClass: 'slick-dots hero__slider-dots',
		rows: 0,
		speed: 1000,
		prevArrow: $heroPrevArrowEl,
		nextArrow: $heroNextArrowEl,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					centerPadding: '25px',
					slidesToShow: 1,
					waitForAnimate: false,
					speed: 500,
				}
			},
		]
	});

	const onWindowResize = function() {
    	if ($heroPrevArrowEl && $heroNextArrowEl) {
			const $heroContainer = document.querySelector('.hero__container');
			const $heroSlide = document.querySelector('.hero__slide');

			// Magic number 1.9387 represents hero slide width of 193.87%
			$heroPrevArrowEl.style.width = `${($heroContainer.offsetWidth - ($heroSlide.offsetWidth * 1.9387)) / 2}px`;
			$heroNextArrowEl.style.width = `${($heroContainer.offsetWidth - ($heroSlide.offsetWidth * 1.9387)) / 2}px`;
		}
    };

	const debouncedWindowResize = debounce(250, onWindowResize);

    window.addEventListener('resize', debouncedWindowResize);

  	document.querySelectorAll('.js-hero-slide-action').forEach(el => {
  		el.addEventListener('click', event => {
  			event.preventDefault();

  			const $currentSlide = document.querySelector(`[data-slide-index="${event.target.dataset.slideIndex}"]`);

  			if (!$currentSlide) {
	      		return;
	    	}

	    	window.track.trackSelectPromotion($currentSlide.dataset);
  		})
	})

	const $anchors = document.querySelectorAll('.js-anchor');
	if ($anchors.length) {
		$anchors.forEach((anchor) => {
			anchor.addEventListener('click', event => {
				event.preventDefault();

				const anchorHref = event.target.getAttribute('href');
				const elementToScroll = document.querySelector(`${anchorHref}`);
				const headerHeight = 60;

				if (elementToScroll) {
					window.scrollTo({
						top: elementToScroll.getBoundingClientRect().top + window.scrollY - headerHeight,
						left: 0,
						behavior: "smooth",
					});
				}
			})
		})
	}

	if (document.querySelectorAll('.js-track-select-item').length) {
		document.querySelectorAll('.js-track-view-item-list').forEach(el => {
			window.track.trackViewItemList(el);
		})

		document.querySelectorAll('.js-track-select-item').forEach(el => {
	  		el.addEventListener('click', event => {
	  			event.preventDefault();
	  			window.track.trackSelectItem(event.currentTarget.dataset)
	  		})
		})
	}
};
